import { Cascader, Form, Input } from 'antd';
import { useEffect, useState } from 'react';
import { getRules, getMessage } from '../util';
import { buildTree, fetchCascaderData, getCacheKey } from './utils';

/**
 * BaseCascader — 通用级联基类组件
 *
 * 功能：
 *   1. 通过 setting.data_source_address 动态取数
 *   2. 按 data_source 做 Storage 缓存
 *   3. 将扁平数组转为树形结构（通用逻辑）
 *   4. 层级完全由数据决定，不裁剪
 *   5. 渲染 <Cascader> 并处理 onChange 设置表单值
 *
 * 子类可重写的方法：
 *   - convertToTree(rawData, setting): 自定义扁平→树转换逻辑
 *   - handleChange(value, selectedOptions): 自定义 change 处理（含层级校验等）
 */
const BaseCascader = (props) => {
    let [options, setOptions] = useState([]),
        [loading, setLoading] = useState(true),
        { setting, updated, desc, form, field_type,
          // 子类可注入：自定义转换方法
          customConvertToTree,
          // 子类可注入：自定义 change 处理
          customHandleChange
        } = props;

    const disabled = updated !== 0;
    let multiple = setting.type !== 'single';

    /** 默认转换方法（子类可通过 customConvertToTree 覆盖） */
    const convertFn = customConvertToTree || ((rawData) => {
        return buildTree(rawData);
    }),

    /** 默认 change 处理（子类可通过 customHandleChange 覆盖） */
     handleChangeFn = customHandleChange || ((value, selectedOptions) => {
        const nameArray = selectedOptions?.map((option) => option.label);
        form?.setFieldsValue({ [`${props.en_name}_name`]: nameArray });
    }),

     handleInitial = async () => {
        const dataSource = setting.data_source,
         address = setting.data_source_address || setting.requestUrl;
        if (!address) {
            setLoading(false);
            return;
        }

        const cacheKey = getCacheKey(dataSource),
         rawData = await fetchCascaderData(address, cacheKey),
         treeOptions = convertFn(rawData, setting);
        setOptions(treeOptions);
        setLoading(false);
    };

    useEffect(() => {
        handleInitial();
    }, []);

    return (
        <>
            <Form.Item key={props.field_id} label={props.label === undefined ? props.name : props.label} name={props.en_name} rules={getRules(props)}>
                <Cascader
                    loading={loading}
                    disabled={disabled}
                    multiple={multiple}
                    options={options}
                    placeholder={desc || getMessage(field_type)}
                    onChange={handleChangeFn}
                ></Cascader>
            </Form.Item>
            <Form.Item name={`${props.en_name}_name`} style={{ display: 'none' }}>
                <Input hidden></Input>
            </Form.Item>
        </>
    );
};

// 暴露给子类的可重写方法标识
BaseCascader.convertToTree = function () { /* placeholder */ };
BaseCascader.handleChange = function () { /* placeholder */ };

export default BaseCascader;
